<template lang="pug">
	.template-update(v-if="showed")
		.card
			.card-header
				i.fa.fa-edit
				span Update {{ getTypeTitle() }} Template
			.card-body.collapse.show
				.form-horizontal
					.form-group
						label.col-form-label Are you sure you want to save changes in {{ getType().toLowerCase() }} template "{{title}}"? This action can't be undone.
				.form-horizontal.info-holder
					.form-group
						div.info-item(v-for="inf in info" v-html="inf")
				.form-horizontal
					.form-actions
						button.btn.btn-danger(type="submit" v-on:click="updateTemplate()") Update {{ getType().toLowerCase() }} template
						button.btn.btn-ghost-dark(type="button" v-on:click="cancel()") Cancel
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Creative } 			from './../../services/Creative';
	import { Version } 			from './../../services/Version';
	import { Settings } 		from './../../services/Settings';

	export default {
		name: "TemplateUpdate",
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {
				"Show TemplateUpdate": function(versionId, info, type) {

					this.versionId = versionId;
					this.info = info;
					this.type = type;

					this.update();

				},
				"Show BannerTemplateUpdate": function(versionId, info) {

					this.versionId = versionId;
					this.info = info;
					this.type = 'banner';

					this.update();

				},
				"Show StoryboardTemplateUpdate": function(versionId, info) {

					this.versionId = versionId;
					this.info = info;
					this.type = 'storyboard';

					this.update();

				}
			}
		},
		data() {

			this.Creative = Creative;
			this.Settings = Settings;

			return {
				title: '',
				versionId: null,
				info: [],
				type: null
			};

		},
		methods: {
			getType() {

				if (this.type) return this.type;

				if (this.versionId) {
					let version = Version.getVersion(this.versionId);
					if (version) {
						let creative = Creative.getCreative(version["creative_id"]);
						if (creative?.type) return creative.type;
						if (version.options?.templateId) {
							let t = Metadata.Templates?.[version.options.templateId];
							if (t?.type) return t.type;
						}
					}
				}

				return 'banner';

			},
			getTypeTitle() {

				return this.getType() === 'storyboard' ? 'Storyboard' : 'Banner';

			},
			collectData(reason, versionId, info, type) {

				if (versionId) this.versionId = versionId;
				if (info) this.info = info;
				if (type) this.type = type;

				let version = Version.getVersion(this.versionId);
				if (!version) return;

				let templateId = version.options?.templateId;
				this.templateProps = Metadata.Templates?.[templateId];

				this.title = this.templateProps?.title || '';

			},
			updateTemplate() {

				Server.sendToSocket({
					ExecuteTemplateUpdate: {
						templateCodename: this.templateProps?.codename || '',
						versionId: this.versionId
					}
				});

				this.hide();

			},
			cancel() {

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.template-update, .banner-template-update
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 1280px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 580px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.btn-ghost-dark
				float: right
				color: #fff

		.info-holder
			height: 390px
			overflow: auto
			margin-bottom: 10px

			.info-item
				font-size: 12px

		secondary
			color: var(--secondary)

		gray
			color: var(--gray)

		green
			color: var(--green)

		yellow
			color: var(--yellow)

		orange
			color: var(--orange)

		danger
			color: var(--danger)

</style>
